export const FilesSvg = () => {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.51392 1.57634C7.46106 1.00939 7.16392 0.544351 6.71091 0.249394C6.20023 -0.0831074 5.56763 -0.0831576 5.05691 0.249401C4.6039 0.544383 4.30677 1.00939 4.25391 1.57634H2.35489V2.88997H0V17H10.9055V14.5792H13V4.53129L10.1276 1.57634H7.51392ZM6.49395 2.6948H3.44279V13.4607H11.9121V6.2416H9.35821V2.6948H7.52239V6.04933C7.52239 6.69149 7.21856 7.29432 6.71092 7.62487C6.2002 7.95743 5.5676 7.95738 5.05692 7.62488C4.54927 7.29435 4.24544 6.69149 4.24544 6.04933V4.17565H5.27388V6.04933C5.27388 6.31275 5.39871 6.54647 5.58647 6.66883C5.77137 6.78905 5.99642 6.78906 6.18137 6.66882C6.3691 6.54652 6.49395 6.31279 6.49395 6.04933V2.6948ZM6.46818 1.57634C6.43973 1.48501 6.38722 1.40466 6.30819 1.31557C6.1919 1.1845 6.0387 1.11525 5.88387 1.11525C5.72902 1.11525 5.57592 1.18447 5.45966 1.31554C5.38062 1.40465 5.3281 1.48502 5.29964 1.57634H6.46818ZM9.81758 14.5792H2.35489V4.00843H1.08789V15.8815H9.81758V14.5792ZM10.4461 3.48602V5.12314H12.0387L10.4461 3.48602Z"
        fill="#448ABF"
      />
    </svg>
  );
};
